import FundRequestsList from '../funds/FundRequestsList';
const AccountantFundRequestsList = () => <FundRequestsList />;
export default AccountantFundRequestsList; 